import React from 'react';
import { toDateTime } from '../../../helpers/Format';
import { Texto } from '../Texto';
export var BlockDate = function (_a) {
    var fecha = _a.fecha, align = _a.align, fontSize = _a.fontSize, bold = _a.bold;
    return (React.createElement(Texto, { texto: toDateTime(fecha), align: align, fontSize: fontSize, bold: bold }));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockDate.tsx
// module id = 259
// module chunks = 0